import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";

import { SeoLink, type SeoLinks } from "../../types/seo-link.types";

@Component({
    selector: "h-seo-links",
    imports: [CommonModule],
    templateUrl: "./seo-links.component.html",
    styleUrls: ["seo-links.component.scss"],
})
export class SeoLinksComponent {
    @Input()
    public seoLinks?: SeoLinks;

    @Input()
    public isNoScriptElement: boolean = false;

    public trackByLink(index: number, item: SeoLink): string {
        return `${index}_${item.label ?? "unknown"}`;
    }
}
